export default "__VITE_ASSET__D1jStuqj__"